import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Card": Card, "@mui/material/CardActions": CardActions, "@mui/material/CardContent": CardContent, "@mui/material/CardMedia": CardMedia, "@mui/material/Button": Button, "@mui/material/Typography": Typography } } });
export default ClientProvider;
